import React from 'react'
import { Main, About, Quote, Word} from '../components'
const Home = () => {
  return (
    <>
        <Main />
        <About />
        <Quote/>
        {/* <Word /> */}
        {/* <Magazine /> */}

    </>
  )
}

export default Home